<template>
    <div class="h-px bg-white/10 my-1" />
</template>
